// extracted by mini-css-extract-plugin
export var redoItem = "_ig-1";
export var redoTrigger = "_ig-0";